export const first = [

    {
        title:"一、单位的基本情况",
        formName:"",
        child:[
            {
                subTitle:"单位基本情况",
                subDesc:"单位名称、地址、使用功能、建筑面积、建筑结构及主要人员等情况",
                formName:"baseJibenqk",
                value:"",
                delable:true,
            },
            {
                subTitle:"消防安全重点部位",
                subDesc:"消防控制室、消防水泵房、变配电室、厨房、空调机房、发电机房、可燃物品仓库、集体宿舍等部位",
                formName:"xiaofangZhongdian",
                value:"",
                delable:true,
            },
            {
                subTitle:"消防安全重点部位",
                subDesc:"火灾自动报警、自动喷水灭火、防排烟、气体灭火、室内、外消火栓、灭火器等",
                formName:"xiaofangSheShi",
                value:"",
                delable:true,
            },
            {
                subTitle:"消防组织、志愿消防队人员及装备配备情况",
                subDesc:"消防管理归口部门、志愿消防队人员情况、微型消防站器材配备情况等",
                formName:"xiaofangPeibei",
                value:"",
                delable:false,
            },
         
        ],
        desc:"",
        delable:false,
    },
    {
        title:"二、应急组织机构演练人员及主要职责记录",
        formName:"personRecord",
        child:[
            {
                subTitle:"火场指挥组：",
                subDesc:"负责现场指挥。指挥协调各职能小组和志愿消防队（微型消防站）队员开展工作，组织实施火灾扑救及人员疏散工作。待消防救援队伍到达现场后，及时向指挥员报告火场内的有关情况，按照指挥员的统一部署，协调配合消防队伍开展灭火救援行动",
                formName:"zhihuiName",
                value:"",
                delable:false,
            },
            {
                subTitle:"灭火行动组：",
                subDesc:"负责现场灭火、抢救被困人员、操作消防设施等工作。",
                formName:"miehuoName",
                value:"",
                delable:false,
            },
            {
                subTitle:"疏散引导组：",
                subDesc:"负责引导人员疏散自救，确保人员安全快速疏散至安全区域。",
                formName:"shusanName",
                value:"",
                delable:true,
            },
            {
                subTitle:"安全防护救护组：      ",
                subDesc:"负责对受伤人员进行紧急救护，并视伤情转送医疗机构",
                formName:"jiuhuName",
                value:"",
                delable:true,
            },
            {
                subTitle:"火灾现场警戒组：",
                subDesc:"负责控制各出入口，禁止无关人员进入；待火灾扑灭后保护现场。",
                formName:"jingjieName",
                value:"",
                delable:true,
            },
            {
                subTitle:"后勤保障组：",
                subDesc:"负责通信联络、车辆调配、道路畅通、供电控制、水源保障。",
                formName:"baozhangName",
                value:"",
                delable:true,
            },
            {
                subTitle:"通信联络组：      ",
                subDesc:"负责操作消防自动控制系统，并与指挥机构和当地消防部门、区域联防单位及其他应急行动涉及人员的通信、联络。",
                formName:"lianluoName",
                value:"",
                delable:true,
            },
            {
                subTitle:"机动组：",
                subDesc:"接受火场指挥组的指挥，负责增援行动。",
                formName:"jidongName",
                value:"",
                delable:true,
            },
            
        ],
        desc:"",
        delable:false,
    },
    {
        title:"三、应急组织机构演练人员及主要职责记录",
        formName:"",
        child:[
            {
                subTitle:"起火时间段:",
                subDesc:"",
                formName:"fireTime",
                value:"",
                delable:false,
            },
            {
                subTitle:"起火位置：",
                subDesc:"",
                formName:"fireLocation",
                value:"",
                delable:false,
            },
            {
                subTitle:"起火物品：",
                subDesc:"",
                formName:"fireThing",
                value:"",
                delable:true,
            },
            {
                subTitle:"燃烧范围及火势蔓延情况：",
                subDesc:"",
                formName:"qihuoFangxiang",
                value:"",
                delable:true,
            },
            {
                subTitle:"消防安全重点部位：",
                subDesc:"",
                formName:"zhuyhaoQihuo",
                value:"",
                delable:true,
            },
            {
                subTitle:"火灾造成的危害和影响：",
                subDesc:"",
                formName:"weihaiHouguo",
                value:"",
                delable:true,
            },
          
            
        ],
        desc:"",
        delable:false,
    }
]